<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M676.67 516.34l2886.37 0 0 1924.24 -2886.37 0 0 -1924.24 0 0zm1443.22 481.03c265.63,0 481.09,215.46 481.09,481.09 0,265.58 -215.46,481.03 -481.09,481.03 -265.64,0 -481.03,-215.45 -481.03,-481.03 0,-265.63 215.39,-481.09 481.03,-481.09l0 0zm-801.82 -160.3c0.12,177.09 -143.52,320.73 -320.61,320.73l-0.06 641.39c177.15,-0.12 320.79,143.52 320.79,320.61l1603.45 0.06c0,-177.15 143.64,-320.79 320.73,-320.79l0 -641.33c-177.09,0.06 -320.73,-143.58 -320.73,-320.67l-1603.57 0 0 0zm-1282.79 320.67l320.67 0 0 1603.57 2565.69 0 0 320.67 -2886.36 0 0 -1924.24z"/>
  </g>
 </g>
</svg>
